import React, { useRef } from 'react';
import { Button, ThemeProvider } from '@alphonsocode/kallos';
import SingleSelectDropdown from 'containers/NewCreativePreview/components/Filter Modal/singleSelectDropdown';
import * as S from '../../../../PodHomePage/components/Screen/components/OnDemandModal/style';
import MultiSelectDropdown, {
  Option,
} from '../../Filter Modal/multiSelectDropdown';
import { is } from 'bluebird';

interface MosaicFormProps {
  campaignID: string;
  creativeID: string;
  validateError: string;
  adslotState: boolean;
  selectedAdslot: Option | null;
  creativeAdslots: Option[];
  onCampaignIDChange: (value: string) => void;
  onCreativeIDChange: (value: string) => void;
  onValidate: () => void;
  onAdslotChange: (value: Option | null) => void;
  setIsOpen: (value: boolean) => void;
  onOSVersionChange: (value: Option[] | null) => void;
  selectedOSVersion: Option[] | null;
  osVersionOptions: Option[];
  isOSVFetching: boolean;
  isOSVLoading: boolean;
}

export const MosaicForm = ({
  campaignID,
  creativeID,
  validateError,
  adslotState,
  selectedAdslot,
  creativeAdslots,
  onCampaignIDChange,
  onCreativeIDChange,
  onValidate,
  onAdslotChange,
  setIsOpen,
  onOSVersionChange,
  selectedOSVersion,
  osVersionOptions,
  isOSVFetching,
  isOSVLoading,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <S.UploadSection ref={scrollRef}>
      <S.AssetLabel>Use Existing Creatives</S.AssetLabel>
      <S.SubText>Provide Campaign ID and Creative ID</S.SubText>
      <S.FormSection ref={scrollRef}>
        <S.FormRow>
          <S.FormGroup>
            <S.Label>Campaign ID</S.Label>
            <S.Input
              value={campaignID}
              onChange={e => onCampaignIDChange(e.target.value)}
              style={{ width: 300 }}
            />
          </S.FormGroup>
        </S.FormRow>
        <S.FormRow>
          <S.FormGroup>
            <S.Label>Creative ID</S.Label>
            <S.Input
              value={creativeID}
              onChange={e => onCreativeIDChange(e.target.value)}
              style={{ width: 300 }}
            />
          </S.FormGroup>
        </S.FormRow>
        <S.FormRow>
          <S.FormGroup>
            <span
              style={{
                color: 'red',
                fontSize: 12,
                marginBottom: 8,
                fontWeight: 700,
              }}
            >
              {validateError}
            </span>
            <ThemeProvider defaultMode="light">
              <Button
                onClick={onValidate}
                colorVariant="deepGreen"
                variant="rounded"
                disableHoverEffect={true}
                style={{ width: 100 }}
              >
                Validate
              </Button>
            </ThemeProvider>
          </S.FormGroup>
        </S.FormRow>
        {adslotState && (
          <S.FormRow>
            <S.FormGroup>
              <S.Label>Ad Slot</S.Label>
              <div style={{ width: 400 }}>
                <SingleSelectDropdown
                  placeholder="Select..."
                  value={selectedAdslot}
                  onChange={onAdslotChange}
                  loadOptions={inputValue => {
                    if (!inputValue) return Promise.resolve(creativeAdslots);
                    const filtered = creativeAdslots.filter(item =>
                      item.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()),
                    );
                    return Promise.resolve(filtered);
                  }}
                  defaultOptions={creativeAdslots}
                  isLoading={false}
                  setIsOpen={setIsOpen}
                />
              </div>
            </S.FormGroup>
          </S.FormRow>
        )}
        {adslotState && selectedAdslot && (
          <S.FormRow>
            <S.FormGroup>
              <S.Label>OS Version</S.Label>
              <div style={{ width: 370 }}>
                <MultiSelectDropdown
                  placeholder="Select..."
                  value={selectedOSVersion || []}
                  onChange={onOSVersionChange}
                  defaultOptions={osVersionOptions} // loaded once from API
                  loadOptions={inputValue => {
                    if (!inputValue) return Promise.resolve(osVersionOptions);
                    const filtered = osVersionOptions.filter(item =>
                      item.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()),
                    );
                    return Promise.resolve(filtered);
                  }}
                  isLoading={isOSVLoading || isOSVFetching}
                  setIsOpen={setIsOpen}
                  disabled={false}
                />
              </div>
            </S.FormGroup>
          </S.FormRow>
        )}
      </S.FormSection>
    </S.UploadSection>
  );
};
